// extracted by mini-css-extract-plugin
module.exports = {"main":"MessageDetailDisplay_main__9e1n7"};